module.exports = __webpack_public_path__ + "static/img/canni.5f7d406.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/canni.png
// module id = Wt8z
// module chunks = 5